import { render, staticRenderFns } from "./DocumentTypeDetailList.vue?vue&type=template&id=fc94d2ec&"
import script from "./DocumentTypeDetailList.vue?vue&type=script&lang=js&"
export * from "./DocumentTypeDetailList.vue?vue&type=script&lang=js&"
import style0 from "./DocumentTypeDetailList.vue?vue&type=style&index=0&id=fc94d2ec&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports